import * as React from 'react';
import './Submission.css';

const Submission = ({ submission }) => {
    return (
        <tr>
            <td><a href={`https://tlx.toki.id/${submission.problemUrl}`}>{ submission.problemName }</a></td>
            <td className='verdict'>{ submission.verdict }</td>
            <td>{ submission.score }</td>
            <td><a href={`https://tlx.toki.id/submissions/${submission.id}`}>{ submission.id }</a></td>
        </tr>
    );
}

export default Submission;